<template>
  <div>
    <vx-card class="addedit-vessel-card">
      <div class="header mb-6">
        <div class="w-full justify-right">
          <h2 class="pl-2">Report Analyst</h2>
        </div>
      </div>

      <div class="vx-row w-full m-0">
        <div class="vx-col sm:w-full md:w-1/1 px-0 mb-4">
          <label>Report File</label>
          <file-picker
            ref="filePicker"
            :acceptFormat="['.pdf', '.doc', '.docx']"
            :isMultiple="false"
          />
        </div>
      </div>

      <div class="mt-2 btn-lead flex justify-center">
        <vs-button
          class="vs-button vs-button-primary login-btn"
          :disabled="button_loading"
          @click="submitReport"
        >
          Submit
        </vs-button>
      </div>

      <div class="mt-2 table-responsive" v-if="aiResponse">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Main Area</th>
              <th>Area</th>
              <th>Grade</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="area in aiResponse">
              <tr
                v-for="(subSection, subIndex) in area.subSections"
                :key="`${area.mainArea}-${subIndex}`"
              >
                <template v-if="subIndex === 0">
                  <td :rowspan="area.subSections.length">{{ area.mainArea }}</td>
                </template>
                <td>{{ subSection.reason.area }}</td>
                <td>{{ subSection.reason.grading }}</td>
                <td>{{ subSection.reason.justification }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FilePicker from "@/components/file-picker.vue";

export default {
  components: { FilePicker },
  data() {
    return {
      aiResponse: null,
      button_loading: false,
    };
  },
  methods: {
    async submitReport() {
      const files = this.$refs.filePicker.selectedFiles || [];

      if (!files.length) {
        this.$vs.notify({
          title: "Error.",
          text: "Please choose a file",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.button_loading = true;
      this.$vs.loading();
      this.aiResponse = null;

      try {
        const res = await this.aiReportAnalyst(files[0].file);
        this.$vs.loading.close();
        this.button_loading = false;

        const originalString =
                              res &&
                              res.data &&
                              res.data.data &&
                              res.data.data[0] &&
                              res.data.data[0].content &&
                              res.data.data[0].content[0] &&
                              res.data.data[0].content[0].text &&
                              res.data.data[0].content[0].text.value;

        if (!originalString) throw new Error("No content received.");

        const codeBlocks = this.extractCodeBlocks(originalString);

        if (codeBlocks.length > 0) {
          this.aiResponse = JSON.parse(codeBlocks[0]);
        } else {
          // fallback if no code block found
          this.aiResponse = [
            {
              mainArea: "General",
              subSections: [
                {
                  area: "Message",
                  grading: "-",
                  reason: originalString,
                },
              ],
            },
          ];
        }
      } catch (err) {
        console.error("Error parsing AI response:", err);
        this.$vs.notify({
          title: "Error",
          text: "Failed to analyze report. Please try again or check format.",
          color: "danger",
          position: "top-right",
        });
        this.button_loading = false;
        this.$vs.loading.close();
      }
    },

    extractCodeBlocks(text) {
      const regex = /```(?:json)?\n([\s\S]*?)```|~~~(?:json)?\n([\s\S]*?)~~~/g;
      const matches = [];
      let match;

      while ((match = regex.exec(text)) !== null) {
        const block = match[1] || match[2];
        if (block) matches.push(block.trim());
      }

      return matches;
    },
  },
};
</script>
